import { Auth } from 'aws-amplify'

export const cognitoResendSignUp = async (username) => {
  let result = {
    isError: false,
  }

  try {
    result.data = await Auth.resendSignUp(username)
  } catch (error) {
    result.isError = true
    result.data = error
  }

  return result
}
